var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 18,
  viewBox: "0 0 17 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2190",
  "data-name": "Group 2190",
  transform: "translate(-1025 -367)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2188",
  "data-name": "Group 2188"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1594",
  "data-name": "Group 1594",
  transform: "translate(1025.835 376.376)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M24.305,297.323,21.3,294.958a.367.367,0,0,1-.119-.484h0a1.928,1.928,0,0,1,2.322-.6l2.719,1.543Z",
  transform: "translate(-21.13 -293.724)",
  fill: "#d0cfce"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M127.039,363.928l2.371,3.013a.367.367,0,0,0,.484.119l.179-.124a1.631,1.631,0,0,0,.5-1.964l-1.63-2.954Z",
  transform: "translate(-122.854 -359.321)",
  fill: "#d0cfce"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2187",
  "data-name": "Group 2187"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M9.559,62.323l3.71-3.71L1.777,55a.65.65,0,0,0-.628.154l-.971.971a.758.758,0,0,0,.273,1.168Z",
  transform: "translate(1024.999 314.193)",
  fill: "#d0cfce"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M271.16,179.9l3.71-3.71,3.61,11.491a.65.65,0,0,1-.154.628l-.971.971a.758.758,0,0,1-1.168-.273Z",
  transform: "translate(761.324 195.54)",
  fill: "#d0cfce"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M87.407,4.837l-5.225,5.58A28.991,28.991,0,0,1,79.4,13.027l-2.486,2.037a1.2,1.2,0,0,1-1.628.136h0a1.414,1.414,0,0,1,.127-1.739l1.907-2.655a29.741,29.741,0,0,1,2.443-2.974l5.225-5.58a8.714,8.714,0,0,1,2.4-1.835c.746-.376,1.54-.611,1.925-.2s.165,1.259-.187,2.056A9.281,9.281,0,0,1,87.407,4.837Z",
  transform: "translate(952.484 367)",
  fill: "#e3e3e3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M89.6.241a.737.737,0,0,0-.539-.216,3.724,3.724,0,0,1-.389,1.494,9.282,9.282,0,0,1-1.718,2.565l-5.225,5.58a28.982,28.982,0,0,1-2.784,2.609L76.464,14.31a1.521,1.521,0,0,1-1.121.387.928.928,0,0,0,.234.526h0a1.2,1.2,0,0,0,1.628-.136l2.486-2.037a28.986,28.986,0,0,0,2.784-2.609L87.7,4.861A9.282,9.282,0,0,0,89.417,2.3C89.769,1.5,89.989.652,89.6.241Z",
  transform: "translate(952.193 366.976)",
  fill: "#d8d8d8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M402.22,49.382l-.213.213c-.2.2-2.408-2.013-2.211-2.211l.213-.213a.447.447,0,0,1,.491-.105h0a3.643,3.643,0,0,1,1.825,1.825h0A.447.447,0,0,1,402.22,49.382Z",
  transform: "translate(637.782 321.826)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M92.237,342.747a.3.3,0,0,1-.21-.506l2.588-2.588a.3.3,0,0,1,.419.419l-2.588,2.588A.3.3,0,0,1,92.237,342.747Z",
  transform: "translate(936.004 39.096)",
  fill: "#fff"
}))))));
export default __webpack_public_path__ + "static/media/shipping-disable.933c9ac7.svg";
export { SvgComponent as ReactComponent };